const numberFormat = new Intl.NumberFormat('en-GB');

// TODO: Unit test.
export const prettyNumber = (number: number) => numberFormat.format(number);
